/**
 * @fileoverview gRPC-Web generated client stub for acompanha.desktop_releases.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/desktop_releases/v1/desktop_releases.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.desktop_releases = {};
proto.acompanha.desktop_releases.v1 = require('./desktop_releases_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest,
 *   !proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse>}
 */
const methodDescriptor_DesktopReleasesService_ListDesktopReleases = new grpc.web.MethodDescriptor(
  '/acompanha.desktop_releases.v1.DesktopReleasesService/ListDesktopReleases',
  grpc.web.MethodType.UNARY,
  proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest,
  proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse,
  /**
   * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServiceClient.prototype.listDesktopReleases =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/ListDesktopReleases',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_ListDesktopReleases,
      callback);
};


/**
 * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServicePromiseClient.prototype.listDesktopReleases =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/ListDesktopReleases',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_ListDesktopReleases);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest,
 *   !proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse>}
 */
const methodDescriptor_DesktopReleasesService_GetLatestDesktopRelease = new grpc.web.MethodDescriptor(
  '/acompanha.desktop_releases.v1.DesktopReleasesService/GetLatestDesktopRelease',
  grpc.web.MethodType.UNARY,
  proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest,
  proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse,
  /**
   * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServiceClient.prototype.getLatestDesktopRelease =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/GetLatestDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_GetLatestDesktopRelease,
      callback);
};


/**
 * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServicePromiseClient.prototype.getLatestDesktopRelease =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/GetLatestDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_GetLatestDesktopRelease);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest,
 *   !proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse>}
 */
const methodDescriptor_DesktopReleasesService_GetDesktopRelease = new grpc.web.MethodDescriptor(
  '/acompanha.desktop_releases.v1.DesktopReleasesService/GetDesktopRelease',
  grpc.web.MethodType.UNARY,
  proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest,
  proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse,
  /**
   * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServiceClient.prototype.getDesktopRelease =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/GetDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_GetDesktopRelease,
      callback);
};


/**
 * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServicePromiseClient.prototype.getDesktopRelease =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/GetDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_GetDesktopRelease);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest,
 *   !proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse>}
 */
const methodDescriptor_DesktopReleasesService_CreateDesktopRelease = new grpc.web.MethodDescriptor(
  '/acompanha.desktop_releases.v1.DesktopReleasesService/CreateDesktopRelease',
  grpc.web.MethodType.UNARY,
  proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest,
  proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse,
  /**
   * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServiceClient.prototype.createDesktopRelease =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/CreateDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_CreateDesktopRelease,
      callback);
};


/**
 * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServicePromiseClient.prototype.createDesktopRelease =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/CreateDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_CreateDesktopRelease);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest,
 *   !proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse>}
 */
const methodDescriptor_DesktopReleasesService_UpdateDesktopRelease = new grpc.web.MethodDescriptor(
  '/acompanha.desktop_releases.v1.DesktopReleasesService/UpdateDesktopRelease',
  grpc.web.MethodType.UNARY,
  proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest,
  proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse,
  /**
   * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServiceClient.prototype.updateDesktopRelease =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/UpdateDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_UpdateDesktopRelease,
      callback);
};


/**
 * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServicePromiseClient.prototype.updateDesktopRelease =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/UpdateDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_UpdateDesktopRelease);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_DesktopReleasesService_DeleteDesktopRelease = new grpc.web.MethodDescriptor(
  '/acompanha.desktop_releases.v1.DesktopReleasesService/DeleteDesktopRelease',
  grpc.web.MethodType.UNARY,
  proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServiceClient.prototype.deleteDesktopRelease =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/DeleteDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_DeleteDesktopRelease,
      callback);
};


/**
 * @param {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.desktop_releases.v1.DesktopReleasesServicePromiseClient.prototype.deleteDesktopRelease =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.desktop_releases.v1.DesktopReleasesService/DeleteDesktopRelease',
      request,
      metadata || {},
      methodDescriptor_DesktopReleasesService_DeleteDesktopRelease);
};


module.exports = proto.acompanha.desktop_releases.v1;

